import type { VehicleFilters } from '@models/vehicle'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const vehiclesKeys = {
  root: (companyId: number) => ['companies', companyId, 'vehicles'] as const,
  vehicle: (companyId: number, id: number) =>
    [...vehiclesKeys.root(companyId), id] as const,
  list: (filters: VehicleFilters) =>
    [
      ...vehiclesKeys.root(filters.companyId),
      omit(filters, ['companyId', 'page', 'limit']),
      { page: filters.page, limit: filters.limit },
    ] as const,
}

export const vehiclesUrls = {
  root: (companyId: number) => keyToUrl(vehiclesKeys.root(companyId)),
  vehicle: (companyId: number, id: number) =>
    keyToUrl(vehiclesKeys.vehicle(companyId, id)),
}
